import React, { Component } from "react";
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import { CustomInput, Tooltip } from "reactstrap";
import axios from "axios";
import JsMethod from "../JsMethod";
import CssMethod from "../CssMethod";
import CheckBox from "../CheckBox";
import InputBox from "../InputBox";
import Loading from "../Loading";
import "./style.css";

class AddEdit extends Component {
  constructor(props) {
    super(props);
    this.state = { fetchinprogress: false };
  }

  loadData(id) {
    if (id !== "null") {
      axios
        .get(window.css_js_manager.ajax_url, {
          params: { action: "get_resource", id: id }
        })
        .then(result => {
          this.setState(result.data);
          this.setState({
            fetchinprogress: true
          });
        });
    } else {
      axios
        .get(window.css_js_manager.ajax_url, {
          params: { action: "blank_resource" }
        })
        .then(result => {
          this.setState(result.data);
          this.setState({
            fetchinprogress: true
          });
        });
    }
  }

  componentDidMount() {
    this.loadData(this.props.match.params.id);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.match.params.id !== this.props.match.params.id) {
      this.setState({
        fetchinprogress: false
      });
      this.loadData(nextProps.match.params.id);
    }
  }

  method() {
    if (this.state.type === "css") {
      return (
        <CssMethod
          value={this.state.method}
          onChange={e => {
            this.handleChange(e);
          }}
        />
      );
    } else if (this.state.type === "js") {
      return (
        <JsMethod
          value={this.state.method}
          onChange={e => {
            this.handleChange(e);
          }}
        />
      );
    }
  }

  handleChange(event) {
    this.setState({
      [event.target.name]: event.target.value
    });
  }

  checkboxChange(new_group) {
    let clone = [...this.state.form];
    clone = clone.map(group => {
      if (group.group_id === new_group.group_id) {
        return new_group;
      }
      return group;
    });

    this.setState({
      form: clone
    });
  }

  inputboxChange(new_group) {
    let clone = [...this.state.form];
    clone = clone.map(group => {
      if (group.group_id === new_group.group_id) {
        return new_group;
      }
      return group;
    });

    this.setState({
      form: clone
    });
  }

  form_data() {
    let form = this.state.form;
    let output = form.map((group, index) => {
      if (group.group_type === "checkbox") {
        return (
          <CheckBox
            key={index}
            form_group={group}
            checkboxChange={value => {
              this.checkboxChange(value);
            }}
          />
        );
      } else {
        return (
          <InputBox
            key={index}
            form_group={group}
            inputboxChange={value => {
              this.inputboxChange(value);
            }}
          />
        );
      }
    });
    return output;
  }

  handleSubmit(event) {
    event.preventDefault();
    const data = new FormData(event.target);
    this.setState({
      fetchinprogress: false
    });

    axios
      .post(window.css_js_manager.ajax_url, data, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      })
      .then(result => {
        this.props.history.push("/");
      });
  }

  render() {
    return (
      <React.Fragment>
        {this.state.fetchinprogress === true ? (
          <div className="card bg-light mb-3">
            <div className="card-header d-flex justify-content-between align-items-center">
              <h2>Add {this.state.type === "css" ? "CSS" : "JS"}</h2>
              <div>
                <Link className="btn btn-primary" to="/">
                  Bact to Resource List
                </Link>
              </div>
            </div>
            <div className="card-body">
              <form onSubmit={event => this.handleSubmit(event)}>
                <div className="row">
                  <div className="col-12 col-md-10">
                    <input
                      type="text"
                      name="url"
                      className="form-control inline"
                      placeholder="Complete URL without query string (?v=1.2)"
                      value={this.state.url}
                      required
                      onChange={e => {
                        this.handleChange(e);
                      }}
                    />
                    <input
                      type="hidden"
                      name="id"
                      className="form-control inline"
                      value={this.state.id}
                    />
                    {this.state.id === "" || this.state.id === "null" ? (
                      <input type="hidden" name="action" value="add_resource" />
                    ) : (
                      <input
                        type="hidden"
                        name="action"
                        value="edit_resource"
                      />
                    )}
                  </div>
                  <div className="col-12 col-md-2">
                    <select
                      className="form-control"
                      name="type"
                      value={this.state.type}
                      onChange={e => {
                        this.handleChange(e);
                      }}
                    >
                      <option value="js">JS</option>
                      <option value="css">CSS</option>
                    </select>
                  </div>
                </div>

                {this.method()}

                <div className="mt-3 border-top pt-2">
                  <h5>Selection Logic</h5>
                  <hr />
                  <label className="mr-4">
                    <CustomInput
                      type="radio"
                      name="add_remove"
                      value="add"
                      className="mr-1"
                      checked={this.state.add_remove === "add"}
                      onChange={e => {
                        this.handleChange(e);
                      }}
                      id="add_remove_add"
                      label="Add this"
                      inline
                    />
                  </label>
                  <label className="mr-4">
                    <CustomInput
                      type="radio"
                      name="add_remove"
                      value="remove"
                      className="mr-1"
                      checked={this.state.add_remove === "remove"}
                      onChange={e => {
                        this.handleChange(e);
                      }}
                      id="add_remove_remove"
                      label="Remove this"
                      inline
                    />
                  </label>
                  <hr />
                  <label className="mr-4">
                    <CustomInput
                      type="radio"
                      name="apply_on"
                      value="all"
                      className="mr-1"
                      checked={this.state.apply_on === "all"}
                      onChange={e => {
                        this.handleChange(e);
                      }}
                      id="apply_on_all"
                      label="On All Page"
                      inline
                    />
                  </label>
                  <label className="mr-4">
                    <CustomInput
                      type="radio"
                      name="apply_on"
                      value="selected"
                      className="mr-1"
                      checked={this.state.apply_on === "selected"}
                      onChange={e => {
                        this.handleChange(e);
                      }}
                      id="apply_on_selected"
                      label="On Selected Page"
                      inline
                    />
                  </label>
                  {this.state.apply_on === "selected" && (
                    <React.Fragment>{this.form_data()}</React.Fragment>
                  )}
                </div>
                <input type="submit" className="btn btn-primary" value="Save" />
              </form>
            </div>
          </div>
        ) : (
          <Loading />
        )}
      </React.Fragment>
    );
  }
}

export default AddEdit;
